import script from "./AppHeaderFaqThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderFaqThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderFaqThumbnail.vue?vue&type=style&index=0&id=2e4fb6e1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e4fb6e1"]])

export default __exports__